/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_DemoInputs */

const es_home_cta_demo = /** @type {(inputs: Home_Cta_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar Demo`)
};

const en_home_cta_demo = /** @type {(inputs: Home_Cta_DemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request Demo`)
};

/**
* | output |
* | --- |
* | "Request Demo" |
*
* @param {Home_Cta_DemoInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_cta_demo = /** @type {((inputs?: Home_Cta_DemoInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_DemoInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_cta_demo(inputs)
	return en_home_cta_demo(inputs)
});
export { home_cta_demo as "home.cta.demo" }